import { gql } from "@apollo/client";

export const INSTALL_COUNT_QUERY = gql`
  query vendorInstallCount($vendorId: Int!, $localizeInstalls: Boolean!) {
    productCatalogInstallsCount(
      vendorIds: [$vendorId]
      localizeInstalls: $localizeInstalls
    ) {
      count
    }
  }
`;
